import styled from "styled-components";
import FlexBox, { FlexGrow } from "./FlexBox";
import Icon, { ClickableIcon } from "./Icon";
import Modal from "./Modal";
import { useContext, useEffect, useRef, useState } from "react";
import theme from "../styles/theme";
import Button from "./Button";
import Status from "../types/enum/Status";
import { TextField } from "@mui/material";
import Input from "./Input";
import axios from "axios";
import { VersionContext } from "../context/VersionContext";
import { CancelButton } from "./CourseOverviewModify";

type OptionGroupModalProps = {
  isOpen?: boolean;
  setOpen: (x: boolean) => void;
  confirmFunction?: () => void;
  discardFunction?: () => void;
  title?: string;
  description?: string;
  cancelFunction?: () => void;
  optionGroups: any;
  setOptionGroups: any;
  fetchOptionGroups: any;
  competencyData: any;
  fetchParent: any;
  setIsSnackbarOpen: any;
  setMessage: any;
  setIsErrorOpen: any;
};
const Title = styled.div`
  gap: 10px;
  display: flex;
  align-items: center;
  font-style: normal;
  font-weight: 700;
  font-size: 16px;
  line-height: 24px;
`;
const Body = styled.div`
  padding: 10px;
  fontsize: 14px !important;
`;

const Flex = styled(FlexGrow)`
  //   padding: 18px;
  // width: 350px;
  background: #0066ff1a;
  border-radius: 4px;
  //   margin: 24px 0px;
  color: ${theme.color.darkBlueGray300};
`;

const Block = styled("div")`
  display: flex;
  align-items: center;
`;

const OptionGroupModalNew = ({
  isOpen,
  setOpen,
  title,
  description,
  optionGroups,
  setOptionGroups,
  fetchOptionGroups,
  competencyData,
  fetchParent,
  setIsSnackbarOpen,
  setMessage,
  setIsErrorOpen,
}: OptionGroupModalProps): JSX.Element => {
  const [selectedGroup, setSelectedGroup] = useState<{
    option_group_id: string;
    title: string;
    required_count: number;
    curriculum_version: number;
    competencies: any;
  }>({
    option_group_id: "",
    title: "",
    required_count: 0,
    curriculum_version: 0,
    competencies: [],
  });

  const [addGroupOpen, setAddGroupOpen] = useState(false);
  const [newGroup, setNewGroup] = useState("");
  const [requiredCount, setRequiredCount] = useState(1);

  const { version } = useContext(VersionContext);

  const [editMode, setEditMode] = useState<any>(null);
  const [editData, setEditData] = useState<{
    title: string;
    option_group_id: string;
    required_count: number;
  }>({ title: "", option_group_id: "", required_count: 0 });
  const [toDelete, setToDelete] = useState<any>([]);
  const [toRemoveCom, setToRemoveCom] = useState<any>({ id: "", groupId: "" });
  const inputRef: any = useRef(null);

  const saveNewGroup = (groupName: string, requiredCount: number) => {
    const isDuplicate = optionGroups.find((v: any) => v.title === groupName);

    if (isDuplicate) {
      setIsErrorOpen(true);
      setMessage("Failed to create group! Group name already exists");
      return;
    }
    axios
      .post("/optiongroup/new", {
        title: groupName,
        curriculum_version: version.version_number,
        required_count: requiredCount,
      })
      .then((res) => {
        setAddGroupOpen(false);
        setNewGroup("");
        fetchOptionGroups();
        setIsSnackbarOpen(true);
        setMessage("Created new group successfully!");
      })
      .catch((err: any) => {
        setIsErrorOpen(true);
        setMessage(err?.response.data.error);
      });
  };

  const addCompetency = async (groupId: any) => {
    axios
      .post("/competency/optiongroup/add", {
        template_id: competencyData.id,
        option_group_id: groupId,
        curriculum_version: version?.version_number,
      })
      .then((res: any) => {
        fetchOptionGroups();
        setIsSnackbarOpen(true);
        setMessage(`Added Competency to ${selectedGroup.title}!`);
        fetchParent(selectedGroup.title);
      })
      .catch((err: any) => {
        setIsErrorOpen(true);
        setMessage(err.response.data.error);
      });
  };
  const deleteOptionGroup = async (option_group_id: string) => {
    // e.stopPropagation();
    axios
      .delete(`/optiongroup/delete?option_group_id=${option_group_id}`)
      .then((res) => {
        setIsSnackbarOpen(true);
        if (res.data.optionGroupDeleted) {
          option_group_id === selectedGroup.option_group_id &&
            setSelectedGroup({
              option_group_id: "",
              title: "",
              required_count: 0,
              curriculum_version: 0,
              competencies: [],
            });
          setMessage(`Deleted Option Group(s)!`);
        }
        fetchOptionGroups();
      })
      .catch((err: any) => {
        console.log("hi catch ");
        // setIsErrorOpen(true);
        // setMessage(err?.response?.data?.error);
      });
  };

  const editOpen = (
    e: any,
    option_group_id: string,
    title: string,
    required_count: number
  ) => {
    e.stopPropagation();
    setEditMode(option_group_id);
    setSelectedGroup({
      option_group_id: "",
      title: "",
      required_count: 0,
      curriculum_version: 0,
      competencies: [],
    });
    setEditData({
      title: title,
      option_group_id: option_group_id,
      required_count: required_count,
    });
  };

  const submitEditGroup = () => {
    axios
      .put("optiongroup/update", editData)
      .then(() => {
        setIsSnackbarOpen(true);
        setMessage(`Updated the Option Group Successfully!`);
        fetchOptionGroups();
        setEditMode(null);
        setEditData({ title: "", option_group_id: "", required_count: 0 });
        fetchParent();
      })
      .catch((err: any) => {
        setIsErrorOpen(true);
        setMessage(err.response.data.error);
      });
  };

  const removeCompetency = async (
    template_id: string,
    option_group_id: string
  ) => {
    // e.stopPropagation();
    axios
      .delete(
        `/competency/optiongroup/remove?template_id=${template_id}&option_group_id=${option_group_id}`
      )
      .then((res) => {
        if (res.data.competencyOptionGroupDeleted) {
          setIsSnackbarOpen(true);
          fetchParent();
          setMessage(
            `Removed Competency from ${res.data.competencyOptionGroupDeleted.title}!`
          );
        }
        fetchOptionGroups();
        fetchParent(" ");
      })
      .catch((err: any) => {
        setIsErrorOpen(true);
        setMessage(err.response.data.error);
      });
  };

  const onDeleteOptionGroups = (e: any, id: any) => {
    e.stopPropagation();
    setSelectedGroup({
      option_group_id: "",
      title: "",
      required_count: 0,
      curriculum_version: 0,
      competencies: [],
    });
    setOptionGroups(
      optionGroups.filter((item: any) => item.option_group_id !== id)
    );

    setToDelete([...toDelete, id]);
  };

  const onSaveClick = async () => {
    // setNewGroup("");
    if (editData.title) {
      submitEditGroup();
      await new Promise((resolve) => setTimeout(resolve, 1000));
    }
    setToRemoveCom({ id: "", groupId: "" });
    setToDelete([]);
    if (toDelete?.length > 0) {
      await Promise.all(
        toDelete.map(async (v: any) => {
          await deleteOptionGroup(v);
        })
      );
      setOpen(false);
      await new Promise((resolve) => setTimeout(resolve, 1000));
    }
    if (toRemoveCom.id !== "") {
      await removeCompetency(toRemoveCom.id, toRemoveCom.groupId);
      setOpen(false);
      // Adding a delay of 1 seconds
      await new Promise((resolve) => setTimeout(resolve, 1000));
    }

    if (selectedGroup.option_group_id !== "") {
      addCompetency(selectedGroup?.option_group_id);
      setOpen(false);
      return;
    }
    if (newGroup) {
      saveNewGroup(newGroup, requiredCount);
    }
    // addCompetency(selectedGroup?.option_group_id);
    setOpen(false);
  };
  useEffect(() => {
    selectedGroup &&
      selectedGroup?.option_group_id !== "" &&
      setSelectedGroup(
        optionGroups?.find(
          (v: any) => v.option_group_id === selectedGroup.option_group_id
        )
      );
  }, [optionGroups]);
  console.log(
    "selected",
    selectedGroup?.competencies.some(
      (item: any) => competencyData.competency_code
    )
  );
  return (
    <>
      <Modal
        isOpen={isOpen || false}
        setOpen={setOpen}
        customStyle={{
          overlay: { zIndex: "999999" },
          content: { minWidth: "900px", padding: "0 16px 24px 16px" },
        }}
      >
        <FlexBox style={{ paddingTop: 15 }}>
          <FlexGrow>
            <Title>
              {/* <Icon color="warning">warning_rounded</Icon> */}
              {title}
            </Title>
          </FlexGrow>
          <ClickableIcon
            name="close"
            // color="white"
            onClick={() => setOpen(false)}
          />
        </FlexBox>
        <FlexBox
          style={{ flexWrap: "nowrap", margin: "10px 0px", borderRadius: 3 }}
          justify="between"
          alignItems="none"
        >
          <Flex>
            <Body>
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                }}
              >
                {!addGroupOpen?<div style={{ color: "black" }}>Select an Option Group</div>:<div style={{ color: "black" }}>Create new Option Group</div>}
                {!addGroupOpen && (
                  <Button
                    // disabled={newGroup !== ""}
                    className={newGroup !== "" ? "" : "reduce_opct_onhover"}
                    style={{
                      background: theme.color.blueButton,
                      boxShadow: "0 2px 5px #808080cc",
                      border: "none",
                      width: 120,
                      //   display:'flex',
                      //   alignItems:'center'
                    }}
                    onClick={() => {
                      setAddGroupOpen(true);
                      setSelectedGroup({
                        option_group_id: "",
                        title: "",
                        required_count: 0,
                        curriculum_version: 0,
                        competencies: [],
                      });
                      inputRef.current?.focus();
                    }}
                    status={Status.primary}
                    isOutline={false}
                  >
                    <Icon size={3} name={"add"}></Icon>New
                  </Button>
                )}
              </div>
              {addGroupOpen && (
                <Block
                  style={{
                    justifyContent: "between",
                    gap: 10,
                    marginTop: 10,
                    alignItems: 'start'
                  }}
                >
                  {addGroupOpen && (
                    <div>
                      <div style={{marginBottom:10}}>
                        <div >Group Name</div>
                        <Input
                          onChange={(e: any) => setNewGroup(e.target.value)}
                          placeholder="New Group Name"
                          autoFocus={true}
                          ref={inputRef}
                        />
                      </div>
                      <div>
                      <div >Required Count</div>
                        <Input
                          defaultValue={1}
                          type="number"
                          onChange={(e: any) =>
                            setRequiredCount(e.target.value||0)
                          }
                          placeholder="Required Count"
                          ref={inputRef}
                        />
                      </div>
                    </div>
                  )}

                  <span
                    onClick={() => {
                      setNewGroup("");
                      setAddGroupOpen(false);
                    }}
                    className="reduce_opct_onhover"
                  >
                    <Icon
                      style={{ cursor: "pointer" }}
                      color="#3a44d6"
                      size={3}
                      name={"close"}
                    ></Icon>
                  </span>
                </Block>
              )}
              <div
                style={{
                  background: "white",
                  borderRadius: 2,
                  marginTop: 10,
                  padding: 5,
                  minHeight: 400,
                }}
              >
                {optionGroups.map((v: any) =>
                  editMode !== v.option_group_id ? (
                    <Block
                      onClick={() => {
                        !addGroupOpen &&
                          editMode === null &&
                          setSelectedGroup(v);
                      }}
                      className={!editMode ? "hover" : ""}
                      style={{
                        justifyContent: "space-between",
                        padding: "5px 10px",
                        fontSize: 14,
                        background:
                          selectedGroup?.option_group_id === v?.option_group_id
                            ? "#0061ff"
                            : "",
                        color:
                          selectedGroup?.option_group_id === v?.option_group_id
                            ? "#ffffff"
                            : "",
                      }}
                    >
                      {v.title}
                      {v.option_group_id !== "new" && (
                        <div
                          style={{
                            display:
                              addGroupOpen || editData.title ? "none" : "",
                          }}
                        >
                          <span
                            className="reduce_opct_onhover"
                            onClick={(e: any) =>
                              editOpen(
                                e,
                                v?.option_group_id,
                                v?.title,
                                v?.required_count
                              )
                            }
                          >
                            <Icon color="black" size={3} name={"edit"} />
                          </span>
                          <span
                            className="reduce_opct_onhover"
                            onClick={
                              (e: any) =>
                                onDeleteOptionGroups(e, v?.option_group_id)
                              // deleteOptionGroup(e, v?.option_group_id)
                            }
                          >
                            <Icon color="red" size={3} name={"delete"} />
                          </span>
                        </div>
                      )}
                    </Block>
                  ) : (
                    <div style={{ background: "#0066ff1a", padding: 10 }}>
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "end",
                          cursor: "pointer",
                        }}
                        className="reduce_opct_onhover"
                        onClick={() => {
                          setEditData({
                            title: "",
                            option_group_id: "",
                            required_count: 0,
                          });
                          setEditMode(null);
                        }}
                      >
                        <Icon
                          style={{ cursor: "pointer" }}
                          color="#3a44d6"
                          size={3}
                          name={"close"}
                        ></Icon>
                      </div>
                      <Block
                        style={{
                          padding: "2px 0px",
                        }}
                      >
                        <span style={{ minWidth: 150 }}>Group Title</span>
                        <TextField
                          autoFocus
                          inputRef={inputRef}
                          style={{ width: "100%" }}
                          onChange={(e: any) =>
                            setEditData({ ...editData, title: e.target.value })
                          }
                          value={editData?.title}
                        />
                      </Block>
                      <Block
                        style={{
                          paddingBottom: 10,
                        }}
                      >
                        <span style={{ minWidth: 150 }}>Required Count</span>
                        <TextField
                          type="number"
                          style={{ width: "100%" }}
                          value={editData?.required_count}
                          inputProps={{ min: 1 }}
                          onChange={(e: any) =>
                            setEditData({
                              ...editData,
                              required_count: parseInt(e.target.value),
                            })
                          }
                        />
                      </Block>
                    </div>
                  )
                )}
              </div>
            </Body>
          </Flex>

          {/* competencies list */}
          {selectedGroup?.option_group_id !== "" && (
            <Flex>
              <Body>
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                  }}
                >
                  <div>
                    {" "}
                    <span>Added Competencies</span>
                  </div>
                </div>

                <div
                  style={{
                    background: "white",
                    borderRadius: 2,
                    marginTop: 10,
                    padding: 5,
                    minHeight: 400,
                  }}
                >
                  {
                    <Block
                      style={{
                        justifyContent: "space-between",
                      }}
                    >
                      <div
                        style={{
                          padding: "5px 10px",
                          fontSize: 14,
                          border: "1px dashed #c6d6ff",
                          width: "100%",
                          fontWeight: "bold",
                        }}
                      >
                        {"[" +
                          competencyData.competency_code +
                          "] " +
                          competencyData.title}
                      </div>
                    </Block>
                  }
                  {selectedGroup?.competencies.map((v: any) => (
                    <Block
                      style={{
                        justifyContent: "space-between",
                        display: v.template_id === toRemoveCom.id ? "none" : "",
                      }}
                    >
                      <div style={{ padding: "5px 10px", fontSize: 14 }}>
                        {"[" + v.competency_code + "] " + v.title}
                      </div>
                      <span
                        style={{ display: toRemoveCom.id !== "" ? "none" : "" }}
                        className="reduce_opct_onhover"
                        onClick={(e: any) => {
                          setToRemoveCom({
                            id: v?.template_id,
                            groupId: selectedGroup.option_group_id,
                          });
                          setSelectedGroup({
                            option_group_id: "",
                            title: "",
                            required_count: 0,
                            curriculum_version: 0,
                            competencies: [],
                          });
                        }}
                      >
                        <Icon color="red" size={3} name={"delete"} />
                      </span>
                    </Block>
                  ))}
                </div>
              </Body>
            </Flex>
          )}
        </FlexBox>
        <FlexBox justify="end">
          <div>
            <CancelButton
              className="reduce_opct_onhover"
              style={{
                width: 120,
                boxShadow: "0 2px 5px #808080cc",
                border: "none",
                marginRight: 10,
              }}
              onClick={() => {
                setOpen(false);
                fetchOptionGroups();
              }}
              status={Status.primary}
              isOutline={false}
            >
              Cancel
            </CancelButton>
            <Button
              disabled={
                (!newGroup &&
                selectedGroup.option_group_id === "" &&
                toDelete?.length === 0 &&
                !editData.title &&
                !toRemoveCom)||(addGroupOpen&&!newGroup)
              }
              className="reduce_opct_onhover"
              style={{
                width: 120,
                background: theme.color.blueButton,
                boxShadow: "0 2px 5px #808080cc",
                border: "none",
              }}
              onClick={() => onSaveClick()}
              status={Status.primary}
              isOutline={false}
            >
              Save
            </Button>
          </div>
        </FlexBox>
      </Modal>
    </>
  );
};

export default OptionGroupModalNew;
